export default __webpack_public_path__ + "static/media/portfolio-v3.9db185b5.png";